import { Stack, Typography } from "@mui/material";
import type { GridBasicGroupNode, GridRowId } from "@mui/x-data-grid-premium";
import { useGridApiContext } from "@mui/x-data-grid-premium";
import ExpandCollapseButton from "@entrilia/shared/components/ExpandCollapseButton";
import CollapseIcon from "@entrilia/shared/icons/CollapseIcon";
import ExpandIcon from "@entrilia/shared/icons/ExpandIcon";

interface Props {
  id: GridRowId;
  rowNode: GridBasicGroupNode;
  text: string;
}

const FundLevelGroupName = ({ id, text, rowNode }: Props) => {
  const apiRef = useGridApiContext();

  const handleToggle = () => {
    apiRef.current.setRowChildrenExpansion(id, !rowNode.childrenExpanded);
  };

  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: "center", maxWidth: "100%" }}>
      <ExpandCollapseButton
        expanded={rowNode.childrenExpanded === true}
        onToggle={handleToggle}
        tabIndex={-1}
        ExpandIcon={ExpandIcon}
        CollapseIcon={CollapseIcon}
      />
      <Typography variant="subtitle2" noWrap>
        {text}
      </Typography>
    </Stack>
  );
};

export default FundLevelGroupName;
